module.exports = __webpack_public_path__ + "img/limit.34a9c9af.png";